import React from 'react';
import useImageExists from '../hooks/useImageExists';

const ImageWithFallback = ({ src, fallback, alt, ...props }) => {
  const finalSrc = useImageExists(src, fallback);

  return <img src={finalSrc} alt={alt} {...props} />;
};

export default ImageWithFallback;
